// import { convertFromRaw, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import { Fragment, useState } from 'react'
import Accordion, { AccordionItem } from 'src/components/ui/Accordion'

import type { FAQProperties } from './faq-component'

import './faq-component.scss'

function FAQComponent({ FAQProperties }: FAQProperties) {
  const [indicesExpanded, setIndicesExpanded] = useState<Set<number>>(
    new Set([])
  )

  const onChange = (index: number) => {
    if (indicesExpanded.has(index)) {
      setIndicesExpanded(new Set([]))
    } else {
      setIndicesExpanded(new Set([index]))
    }
  }

  const FAQData = FAQProperties ?? {}

  return (
    <div
      className="FAQAccordion__container"
      style={{
        marginTop: `${FAQData?.marginTop}`,
        marginBottom: `${FAQData?.marginBottom}`,
      }}
    >
      <div className="faq-title-container">
        <span
          className="faq-title-text"
          style={{
            color: `${FAQData?.FAQtitleTextColor}`,
            fontSize: `${FAQData?.FAQtitleTextSize}`,
            fontWeight: `${FAQData?.FAQtitleWeight}`,
          }}
        >
          {FAQData?.FAQtitle}
        </span>
      </div>

      <Accordion expandedIndices={indicesExpanded} onChange={onChange}>
        {FAQData?.FAQQuestion?.map((element: any, index: any) => {
          // const parsedContent = convertFromRaw(
          //   JSON.parse(element?.questionAnswer?.questionAnswerText)
          // )

          // const FAQQuestionContent = draftToHtml(convertToRaw(parsedContent))

          const FAQQuestionContent = element?.questionAnswer?.questionAnswerText
            ? draftToHtml(
                JSON.parse(element?.questionAnswer?.questionAnswerText)
              )
            : ''

          return (
            <Fragment key={index}>
              <AccordionItem
                buttonLabel={element?.questionTitle?.questionTitleText}
                isExpanded={indicesExpanded.has(index)}
                key={element?.questionTitle?.questionTitleText}
                className="FAQ-Accordion"
                style={{
                  color: `${element?.questionTitle?.questionTitleTextColor}`,
                  fontSize: `${element?.questionTitle?.questionTitleTextSize}`,
                  fontWeight: `${element?.questionTitle?.questionTitleTextWeight}`,
                }}
              >
                <div>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: FAQQuestionContent,
                    }}
                    style={{
                      color: `${element?.questionAnswer?.questionAnswerTextColor}`,
                      fontSize: `${element?.questionAnswer?.questionAnswerTextSize}`,
                      fontWeight: `${element?.questionAnswer?.questionAnswerTextWeight}`,
                    }}
                  />
                </div>
              </AccordionItem>
            </Fragment>
          )
        })}
      </Accordion>
    </div>
  )
}

export default FAQComponent
